// Petits utilitaires DOM. La visibilité passe par l'attribut [hidden] (preflight Tailwind v4 : display:none !important)
import { HALO_EMOJI } from '../config/theme.js';

/** Classe à ajouter à un emoji sombre (🎶), détouré d'un halo clair sur le fond de nuit (.emoji-halo) ; '' pour les autres. */
export const haloClass = (emoji) => (HALO_EMOJI.includes(emoji) ? 'emoji-halo' : '');
export const $ = (id) => {
  const el = document.getElementById(id);
  if (!el) throw new Error(`Élément introuvable : #${id}`);
  return el;
};

export const show = (el) => { el.hidden = false; };
export const hide = (el) => { el.hidden = true; };

export function escapeHTML(str) {
  return String(str ?? '').replace(/[&<>'"]/g,
    (tag) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[tag]));
}

/**
 * Espaces insécables de la typographie française (avant ! ? : ; », après «) : un signe de
 * ponctuation ne se retrouve jamais seul en début de ligne. Sans effet sur l'anglais.
 */
export function keepPunctuationAttached(str) {
  return String(str ?? '').replace(/\s+([!?:;»])/g, '\u202F$1').replace(/«\s+/g, '«\u202F');
}

const graphemes = new Intl.Segmenter(undefined, { granularity: 'grapheme' });
const PICTOGRAPHIC = /\p{Extended_Pictographic}/u;

/**
 * Remplit `el` avec `text`, chaque emoji dans un <span class="emoji-inline"> : dans une phrase, les
 * emoji sont dessinés nettement plus grands que le texte (styles/main.css). Nœuds créés un à un :
 * rien n'est interprété comme du HTML.
 */
export function setTextWithEmoji(el, text) {
  const nodes = [];
  let plain = '';
  for (const { segment } of graphemes.segment(String(text ?? ''))) {
    if (!PICTOGRAPHIC.test(segment)) { plain += segment; continue; }
    if (plain) nodes.push(document.createTextNode(plain));
    plain = '';
    const span = document.createElement('span');
    span.className = `emoji-inline ${haloClass(segment)}`.trim();
    span.textContent = segment;
    nodes.push(span);
  }
  if (plain) nodes.push(document.createTextNode(plain));
  el.replaceChildren(...nodes);
}
